(function(){
    /** @ngInject */
    function appConfig($stateProvider,  $urlRouterProvider, $locationProvider){



        $stateProvider
            .state('meals', {
                url: '/',
                //templateUrl: connected_restaurants === null ? 'meals.html' : 'connected-rests.html',
                //controller : connected_restaurants === null ? 'mealsCtrl' : 'ConnectedRestsCtrl'
                templateUrl : 'meals.html',
                controller : 'mealsCtrl'
            })
            .state('amounts', {
                url: '/amount',
                templateUrl: 'amount.html',
                controller : 'amountCtrl'
            })
            .state('calendar', {
                url: '/calendar',
                templateUrl: 'calendar.html',
                controller : 'calendarCtrl'/*,
                    resolve : {
                        loadedFullDays : function(FullDayCache){
                            return FullDayCache.getFullDays();
                        }
                    }*/
            })
            .state('time', {
                url: '/time',
                templateUrl: 'time.html',
                controller : 'timeCtrl'
            })
            .state('giftcard', {
                url: '/giftcard',
                templateUrl: 'giftcard-products.html',
                controller : 'giftcardProductsCtrl'
            })
            .state('guest-details', {
                url: '/guest-details',
                templateUrl: 'guest-form.html',
                controller : 'guestCtrl'
            })
            .state('waitlist-time', {
                url: '/waitlist-time',
                templateUrl: 'waitlist-time.html',
                controller : 'wtimeCtrl'
            })
            .state('terms', {
                url: '/terms',
                templateUrl: 'terms.html',
                controller : 'termsCtrl'
            })
            .state('products', {
                url: '/products',
                templateUrl: 'products.html',
                controller : 'productsCtrl'
            })
            .state('confirm', {
                url: '/confirm',
                templateUrl: 'confirm.html',
                controller : 'confirmCtrl'
            })
            .state('payinwidget',{
                url : '/confirm-cc',
                templateUrl : 'confirm-cc-widget.html',
                controller : 'bookingConfirmationCtrl'
            })
            .state('success', {
                url: '/success',
                templateUrl: 'booking-success.html',
                controller : 'successCtrl'
            })
            .state('success-custom-request', {
                url: '/success-custom-request',
                templateUrl: 'booking-success-custom.html',
                controller : 'customSuccessCtrl'
            })
            .state('connected-rests', {
                url : '/connected-rests',
                templateUrl : 'connected-rests.html',
                controller : 'ConnectedRestsCtrl'
            });
        $urlRouterProvider
            .otherwise('/');
        $locationProvider.html5Mode(true);
        //$compileProvider.
    }
    angular.module("Waiteraid").config(appConfig);
})();
